import React from 'react';
import { Order } from '@/models/order';
import QRCodeViewer from '../QRCodeViewer';
import { getBindOrderQrCodeUrl } from '@/utils/common';
import Modal from '../Modal';
import { Space } from 'antd';
import { message } from '@/components/Message';
import PosButton from '../PosButton';

const BindOrderQRCode = ({ order }: { order: Order }) => {
  return (
    <Space direction="vertical" align="center" className="width-full">
      <QRCodeViewer text={getBindOrderQrCodeUrl(order.orderSn)} width={200} height={200} />
      <div>扫描二维码，即可绑定该订单</div>
      <div>
        <PosButton
          type="primary"
          onClick={() => {
            message.warning(`🚧 功能施工中`);
          }}>
          发送到企微
        </PosButton>
      </div>
    </Space>
  );
};

export interface BindOrderQRCodeModalProps {
  order: Order;
  zIndex?: number;
  onClose?: () => void;
}

export const BindOrderQRCodeModal = ({ order, zIndex, onClose }: BindOrderQRCodeModalProps) => {
  console.log(2222, order);
  console.log(onClose);
  return (
    <Modal
      open={Boolean(order)}
      width={300}
      zIndex={zIndex}
      onCancel={onClose}
      onOk={onClose}
      closable={false}
      footer={
        <Space align="center" className="width-full align-flex-horizontal-center">
          <PosButton onClick={onClose}>关闭</PosButton>
        </Space>
      }>
      <BindOrderQRCode order={order} />
    </Modal>
  );
};
